var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 0C27.9404 0 36 7.94291 36 18C36 27.9072 27.9404 36 17.9996 36C8.05886 36 0 27.9072 0 18C0 7.94291 8.05886 0 17.9996 0Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2629 11.6944C26.0579 11.9085 26.6849 12.5354 26.8989 13.3305C27.2965 14.7831 27.2812 17.8105 27.2812 17.8105C27.2812 17.8105 27.2812 20.8227 26.8989 22.2753C26.6849 23.0704 26.0579 23.6973 25.2629 23.9114C23.8103 24.2936 18 24.2936 18 24.2936C18 24.2936 12.2049 24.2936 10.7371 23.8961C9.94197 23.682 9.31507 23.0551 9.10101 22.26C8.71875 20.8227 8.71875 17.7953 8.71875 17.7953C8.71875 17.7953 8.71875 14.7831 9.10101 13.3305C9.31507 12.5354 9.95726 11.8932 10.7371 11.6791C12.1896 11.2969 18 11.2969 18 11.2969C18 11.2969 23.8103 11.2969 25.2629 11.6944ZM20.9816 17.6891L16.1498 20.4719V14.9062L20.9816 17.6891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4bc77bcccc7b9d0bcc71221ca4a8341a.svg";
export { ForwardRef as ReactComponent };